/**
 * Web Style Import
 *
 */

import './style/dnb-step-indicator.scss'
